import { Arrow, IconButton } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';
import { block } from './utils';

export type AccordionToggleProps = {
  className?: string;
  onToggle: () => void;
};

const AccordionToggle: React.FC<AccordionToggleProps> = ({
  className,
  onToggle,
}) => {
  return (
    <IconButton
      className={cn(block('card-toggle'), className)}
      onClick={() => onToggle()}
    >
      <Arrow />
    </IconButton>
  );
};

export default AccordionToggle;
